<main>
        <div class="contenedor">
            <!-- Header del proyecto -->
            <section class="header-proyecto">
                <div class="imagen-proyecto" style="background-image: url('img/planta-sedapal-main.jpg');"></div>
                <div class="titulo-con-flecha">
                    <a routerLink="/portafolio" class="btn-regreso">
                        <img src="assets/svg/flecha.svg" alt="Regresar">
                    </a>
                    <h1 class="titulo-proyecto">Laguna Huascacocha</h1>
                </div>
                <div class="cuadro_ubicacion">
                    <div class="ubicacion-proyecto">
                    <span class="icono-ubicacion"><img src="assets/svg/IconoMap.svg" alt=""></span>
                        Sierra central – Región Junín
                    </div>
                </div>
                
            </section>

            <!-- Sección de información del proyecto -->
            <section class="seccion-info-proyecto">
                <div class="grid-info">
                    <div class="info-columna">
                        <h3>Importancia</h3>
                        <p>Cuerpo de agua estratégico para la regulación hídrica de la cuenca del Mantaro. Contribuye al control de caudales y garantiza el abastecimiento para consumo humano y agrícola.</p>
                    </div>
                    <div class="separador-vertical"></div>
                    <div class="info-columna">
                        <h3>Descripción del proyecto</h3>
                        <p>Intervención sobre laguna natural con fines de regulación hídrica y posibles usos hidroenergéticos.</p>
                    </div>
                </div>
            </section>

            <!-- Sección de participación -->
            <section class="seccion-participacion">
                <div class="contenido-participacion">
                    <div class="circulo-azul-decorativo"></div>
                    <div class="info-participacion">
                        <h2>Participación de Corporación Rehobot</h2>
                        <p>Se desarrollaron trabajos orientados a garantizar el <strong>abastecimiento del recurso hídrico subterráneo para el campamento</strong>, mediante la perforación y equipamiento de sistemas de bombeo confiables.</p>
                    </div>
                    <div class="imagen-participacion"></div>
                </div>
            </section>

            <!-- Sección de actividades -->
            <section class="seccion-actividades">
                <h2 class="actividades-titulo">Actividades <span>desarrolladas.</span></h2>
                <div class="contenido-actividades">
                    <div class="tarjeta-actividad">
                    </div>
                    <div class="tarjeta-lista-actividades">
                        <ul class="lista-actividades">
                            <li><strong>Perforación de un pozo tubular</strong> para captación de aguas subterráneas.</li>
                            <li><strong>Instalación y equipamiento de sistema de bombeo</strong>, asegurando suministro eficiente para las operaciones.</li>
                            <li><strong>Se ejecutaron tres piezómetros en la represa de la laguna</strong> para el monitoreo y control del nivel freático.</li>
                        </ul>
                    </div>
                </div>
            </section>

            <!-- Sección Más proyectos -->
            <section class="seccion-mas-proyectos">
              <div class="divisor-linea"></div>
              <h2 class="mas-proyectos-titulo">Más <span>proyectos.</span></h2>

              <div class="grid-mas-proyectos">
                <div class="tarjeta-obra-mini" *ngFor="let obra of proyectosRecomendados">
                  <div class="imagen-obra-mini"
                       [style.backgroundImage]="'url(' + obra.imagen + ')'">
                  </div>
                  <div class="contenido-mini">
                    <h3>{{ obra.titulo }}</h3>
                    <a [routerLink]="obra.link" class="btn-conoce-mas">Conoce más</a>
                  </div>
                </div>
              </div>
            </section>
        </div>
    </main>